var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("v-data-table", {
        attrs: {
          headers: _setup.headers,
          dense: "",
          items: _setup.tableServerActions.list
        },
        scopedSlots: _vm._u([
          {
            key: "item.config",
            fn: function({ item }) {
              return [
                !item.locked
                  ? _c(
                      "div",
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              text: "",
                              small: "",
                              color: "yellow darken-3"
                            },
                            on: {
                              click: function($event) {
                                return _setup.onEdit(item)
                              }
                            }
                          },
                          [_c("v-icon", [_vm._v(" mdi-pencil ")])],
                          1
                        ),
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              loading: _setup.locking.has(item.id),
                              text: "",
                              small: "",
                              color: "blue"
                            },
                            on: {
                              click: function($event) {
                                return _setup.lock(item.id)
                              }
                            }
                          },
                          [_c("v-icon", [_vm._v("mdi-lock")])],
                          1
                        )
                      ],
                      1
                    )
                  : _setup.authAccessLevel >= 7
                  ? _c(
                      "div",
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              loading: _setup.locking.has(item.id),
                              text: "",
                              small: "",
                              color: "blue"
                            },
                            on: {
                              click: function($event) {
                                return _setup.unlock(item.id)
                              }
                            }
                          },
                          [_c("v-icon", [_vm._v("mdi-lock-open")])],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]
            }
          },
          {
            key: "item.date_start",
            fn: function({ item }) {
              return [
                _c("div", [
                  _vm._v(
                    " " +
                      _vm._s(
                        _setup.formatDateTimeUS(new Date(item.dateStart))
                      ) +
                      " "
                  )
                ])
              ]
            }
          },
          {
            key: "item.date_end",
            fn: function({ item }) {
              return [
                _c("div", [
                  _vm._v(
                    " " +
                      _vm._s(
                        item.dateEnd
                          ? _setup.formatDateTimeUS(new Date(item.dateEnd))
                          : "ONGOING"
                      ) +
                      " "
                  )
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }